import { oofDtos } from '@vectronic/openApi-customer';

type ArticleType = oofDtos.Article.ArticleTypeEnum;

export const ArticleTypeMetadata: Record<
  ArticleType,
  { name: string; multi: boolean; order: number }
> = {
  COLLAR_CLASS: { name: 'Collar Class', multi: false, order: 1 },
  BATTERY_OPTION: { name: 'Battery Option', multi: true, order: 2 },
  BATTERY_SIZE: { name: 'Battery', multi: false, order: 2 },
  COM_TYPE: { name: 'Com Type', multi: false, order: 3 },
  INTERNAL_DROP_OFF: { name: 'Internal Drop Off', multi: false, order: 4 },
  EXTERNAL_DROP_OFF: { name: 'External Drop Off', multi: false, order: 5 },
  BELT_OPTION: { name: 'Belt Option', multi: true, order: 6 },
  COLLAR_OPTION: { name: 'Collar Option', multi: true, order: 7 },
  TRAP_TRANSMITTER: { name: 'Trap Transmitter', multi: false, order: 8 },
  NO_CONFIG_TYPE: { name: 'No Config Type', multi: false, order: 9 },
};
